module.exports = __webpack_public_path__ + "img/features-homework.30fcfb79.svg";